import React from "react";

import { Navbar, Nav } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import Container from "react-bootstrap/Container";
import { HeaderContainer, Logo, NavItem } from "./header";
import logo from "../../images/logo-light.png";

export default function Header() {
  return (
    <>
      <HeaderContainer>
        <Navbar className="p-0" key="xl" expand="xl">
          <Container fluid>
            <Navbar.Brand href="/">
              <Logo src={logo} alt="logo" className="" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="offcanvasNavbar-expand-xl" />
            <Navbar.Offcanvas
              id="offcanvasNavbar-expand-xl"
              aria-labelledby="offcanvasNavbarLabel-expand-xl"
              placement="end"
              style={{ backgroundColor: "black" }}
            >
              <Offcanvas.Header closeButton closeVariant="white">
                <Offcanvas.Title id="offcanvasNavbarLabel-expand-xl">
                  <Nav.Link href="/" className="p-0">
                    <Logo src={logo} alt="logo" className="" />
                  </Nav.Link>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Nav.Link href="/" className="p-0">
                    <NavItem>Home</NavItem>
                  </Nav.Link>
                  <Nav.Link href="/about" className="p-0">
                    <NavItem>About</NavItem>
                  </Nav.Link>
                  <Nav.Link href="/work" className="p-0">
                    <NavItem>Work</NavItem>
                  </Nav.Link>
                  <Nav.Link href="/contact" className="p-0">
                    <NavItem>Contact</NavItem>
                  </Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </HeaderContainer>
    </>
  );
}
